import { render, staticRenderFns } from "./AccidentsOrTicketsInPast3Years.vue?vue&type=template&id=bb30d722&"
import script from "./AccidentsOrTicketsInPast3Years.vue?vue&type=script&lang=js&"
export * from "./AccidentsOrTicketsInPast3Years.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports